// disable subsequent clicks
ck.clickAndDisable = function(link) {
    link.onclick = function(event) {
    event.preventDefault();
    }
}  
